export default __webpack_public_path__ + "static/media/backgroundDecorator.9115058f.svg";